var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 945,
    height: 1080,
    viewBox: "0 0 945 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_28798)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 945,
    height: 1080,
    fill: "#1EAAC4"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 232,
    cy: 345,
    r: 783,
    fill: "url(#paint0_linear_229_28798)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 111.5,
    cy: 115.5,
    r: 840.5,
    fill: "url(#paint1_linear_229_28798)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 84.5,
    cy: 87.5,
    r: 703.5,
    fill: "url(#paint2_linear_229_28798)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 2,
    cy: 5,
    r: 621,
    fill: "url(#paint3_linear_229_28798)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: -74,
    cy: -71,
    r: 545,
    fill: "url(#paint4_linear_229_28798)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_28798",
    x1: 1764.4,
    y1: 2871.37,
    x2: -146.909,
    y2: -300.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882974,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_229_28798",
    x1: 1756.43,
    y1: 2827.4,
    x2: -295.234,
    y2: -577.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882974,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_229_28798",
    x1: 1461.31,
    y1: 2357.36,
    x2: -255.937,
    y2: -492.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882974,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_229_28798",
    x1: 1217.35,
    y1: 2008.68,
    x2: -298.514,
    y2: -507.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882974,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_229_28798",
    x1: 992.613,
    y1: 1687.46,
    x2: -337.736,
    y2: -520.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882974,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_28798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 945,
    height: 1080,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.0aa2f342a41c9b5c12212a1716345b3a.svg";
export { ForwardRef as ReactComponent };